import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

class SplideSlider extends HTMLElement {
  constructor() {
    super();

    this.generateSplide();    
  }  

  generateSplide() {
    const splideObject = this.getAttribute('data-splide');
    const splideClass = this.getAttribute('data-class');
    const splideObjectJsonData = splideObject ? JSON.parse(splideObject) : {};

    if(!splideClass) return;
    let splide;
    try {
      splide = new Splide(`.${splideClass}`, splideObjectJsonData);
    }
    catch{}

    if(splide) {
      this.generateSplideProgressBar(splide);

      if(splideObjectJsonData.autoScroll) {
        splide?.mount({ AutoScroll });  
      }
      else {
        splide?.mount();  
      }
    }
  }

  generateSplideProgressBar(splide: any) {
    const splideProgressWrapper = this.querySelector('.progress-bar__wrapper') as HTMLElement;

    if(splideProgressWrapper) {
      const splideProgress = splide.root.querySelector('.splide-bar') as HTMLElement;

      splide.on('mounted move drag updated', function () {
        const splideLength = splide.length;
        const perPage = splide.options.perPage || 1;
  
        if(splideLength <= perPage) {
          splideProgressWrapper.classList.add("hidden");
        }
        else {
          splideProgressWrapper.classList.remove("hidden");
  
          const currentIndex = splide.index;
          const pages = Math.ceil(splideLength / perPage);
          const currentPage = Math.ceil(currentIndex / perPage) + 1;
          splideProgress.style.width = String((currentPage / pages) * 100) + "%"; 
        }
      });
    }
  }
}


customElements.define("section-splide", SplideSlider);